import {
  fetchAgents,
  fetchAgent,
  fetchPublicAgent,
  fetchTrashedAgents,
  fetchSystemPrompts,
  fetchSystemPromptsDict,
  fetchSystemPromptByLanguage,
} from './api';

// Query keys
const queryKeys = {
  agents: ['agents'] as const,
  fetchAgents: () => [...queryKeys.agents, 'list'] as const,
  fetchAgent: (agentId: string) => [...queryKeys.agents, 'detail', agentId] as const,
  fetchPublicAgent: (agentId: string) => [...queryKeys.agents, 'public', agentId] as const,
  fetchTrashedAgents: () => [...queryKeys.agents, 'trashed'] as const,

  // System Prompts
  systemPrompts: (agentId: string) => [...queryKeys.agents, agentId, 'system-prompts'] as const,
  fetchSystemPrompts: (agentId: string) => [...queryKeys.systemPrompts(agentId), 'list'] as const,
  fetchSystemPromptsDict: (agentId: string) => [...queryKeys.systemPrompts(agentId), 'dict'] as const,
  fetchSystemPromptByLanguage: (agentId: string, languageCode: string) =>
    [...queryKeys.systemPrompts(agentId), 'language', languageCode] as const,
};

export const agentsQueryOptions = {
  fetchAgents: () => ({
    queryKey: queryKeys.fetchAgents(),
    queryFn: () => fetchAgents(),
  }),
  fetchAgent: (agentId: string) => ({
    queryKey: queryKeys.fetchAgent(agentId),
    queryFn: () => fetchAgent(agentId),
  }),
  fetchPublicAgent: (agentId: string) => ({
    queryKey: queryKeys.fetchPublicAgent(agentId),
    queryFn: () => fetchPublicAgent(agentId),
  }),
  fetchTrashedAgents: () => ({
    queryKey: queryKeys.fetchTrashedAgents(),
    queryFn: () => fetchTrashedAgents(),
  }),

  // System Prompts
  fetchSystemPrompts: (agentId: string) => ({
    queryKey: queryKeys.fetchSystemPrompts(agentId),
    queryFn: () => fetchSystemPrompts(agentId),
  }),
  fetchSystemPromptsDict: (agentId: string) => ({
    queryKey: queryKeys.fetchSystemPromptsDict(agentId),
    queryFn: () => fetchSystemPromptsDict(agentId),
  }),
  fetchSystemPromptByLanguage: (agentId: string, languageCode: string) => ({
    queryKey: queryKeys.fetchSystemPromptByLanguage(agentId, languageCode),
    queryFn: () => fetchSystemPromptByLanguage(agentId, languageCode),
  }),
} as const;

export { queryKeys };

